import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	eventLabel: {
		id: 'data-table-search-result.data-table-label',
		defaultMessage: 'Data Table',
		description: 'Data Table subtype label',
	},
});
